const quoteModule = {
    namespaced: true,
    state: {
        service_type: [
            {
                name: "Loose items (6 items)",
                vehicles: [
                    {
                        name: "Bakkie",
                        price: 1850,
                    }
                ]
            },
            {
                name: "Loose items (20 items)",
                vehicles: [
                    {
                        name: "Bakkie + Trailer",
                        price: 2500,
                    }
                ]
            },
            {
                name: "1 bed flat",
                vehicles: [
                    {
                        name: "Bakkie + Trailer",
                        price: 2500,
                    },
                    {
                        name: "Truck",
                        price: 2450,
                    },
                ]
            },
            {
                name: "2 bed flat",
                vehicles: [
                    {
                        name: "Bakkie + Trailer",
                        price: 2500,
                    },
                    {
                        name: "Truck",
                        price: 2850,
                    },
                ]
            },
            {
                name: "2 bed house",
                vehicles: [
                    {
                        name: "Truck",
                        price: 3500,
                    },
                ]
            },
            {
                name: "3 bed house",
                vehicles: [
                    {
                        name: "Truck + Trailer",
                        price: 4850,
                    },
                    {
                        name: "Bakkie + Truck + Trailer",
                        price: 5850,
                    },
                ]
            },
            {
                name: "4 bed house",
                vehicles: [
                    {
                        name: "1x Truck",
                        price: 5850,
                    },
                    {
                        name: "2x Truck",
                        price: 5200 + " per load",
                    },
                ]
            },
            {
                name: "5 bed house",
                vehicles: [
                    {
                        name: "1x Truck",
                        price: 5850,
                    },
                    {
                        name: "2x Truck",
                        price: 5200 + " per load",
                    },
                ]
            },
        ],

        postal_addresses: [
            {
                name: "strand", start: 7100, end: 7151
            },
            {
                name: "milnerton", start: 7404, end: 7455
            },
            {
                name: "northern suburbs", start: 7456, end: 7583
            },
            {
                name: "stellenbosh", start: 7599, end: 7615
            },
            {
                name: "paarl", start: 7620, end: 7680
            },
            {
                name: "franschhoek", start: 7681, end: 7691
            },
            {
                name: "southern suburbs", start: 7700, end: 7805
            },
            {
                name: "houtbay", start: 7806, end: 7888
            },
            {
                name: "central cape", start: 7915, end: 7937
            },
            {
                name: "woodstock", start: 1451, end: 1451
            },
            {
                name: "south penninsula", start: 7941, end: 7995
            },
            {
                name: "cape town", start: 8000, end: 8060
            },
        ]
    }
}

export default quoteModule;